import { CREATE_EXPERIENCE } from '@ane/antlr/lib/MDLMetrics/models/MetricDefinitionUIModel';
import { METRIC_AUTHORING_MODE, colorSchemeToMetricDirection } from '../CreateModal/CreateModal.constants';
import { parseMetricField } from '../CreateModal/CreateModal.utils';
import { mdlMetricDefinitionGenerator } from '@ane/antlr/lib/MDLMetrics/utils/MdlMetricDefinitionGenerator';
import { DEFAULT_METADATA } from '../CreateModal/CreateModal.constants';
import { MAUIMODES } from '../../../../common/models/MAUI.models';
import { QuickCompilationStatuses } from './QuickValidate.constants';
/**
 * Consider
 * Seems we are using DataVizPalette
 * import { DataVizPalette } from '@fluentui/react-charting';
 */
export const METRIC_DEFINITION_COLORS = {
    0: '#18BFCA',
    1: '#5B5FC7',
    aggregation: '#E43BA6',
};
export const getMetricDefinitionColor = (index) => {
    let color = undefined;
    switch (index) {
        case 0:
            color = METRIC_DEFINITION_COLORS[0];
            break;
        case 1:
            color = METRIC_DEFINITION_COLORS[1];
            break;
        default:
            color = undefined;
            break;
    }
    return color;
};
export const isValidMetadata = (metadata) => {
    if (!metadata) {
        return false;
    }
    if (metadata.mode === METRIC_AUTHORING_MODE.template) {
        return !!metadata.metricTemplate;
    }
    return (!!metadata &&
        !!metadata.name &&
        !!metadata.internalName &&
        !!metadata.description &&
        !!metadata.level &&
        !!metadata.desiredDirection);
};
export const getMetadataFromMetricDetailsWithFilePath = (metricWithFilePath) => {
    var _a, _b;
    const metric = metricWithFilePath === null || metricWithFilePath === void 0 ? void 0 : metricWithFilePath.i;
    return {
        name: ((metric === null || metric === void 0 ? void 0 : metric['foray:DisplayName'])['#text'] || (metric === null || metric === void 0 ? void 0 : metric['foray:DisplayName'])),
        internalName: (metric === null || metric === void 0 ? void 0 : metric['@Name']) || '',
        level: parseMetricField(metric === null || metric === void 0 ? void 0 : metric['@Levels'])[0],
        mode: METRIC_AUTHORING_MODE.custom,
        description: ((_a = metric === null || metric === void 0 ? void 0 : metric['foray:Description']) === null || _a === void 0 ? void 0 : _a['#cdata-section']) || '',
        categories: parseMetricField(metric === null || metric === void 0 ? void 0 : metric['@MetricCategories']),
        desiredDirection: (_b = colorSchemeToMetricDirection[`${metric === null || metric === void 0 ? void 0 : metric['@ColorScheme']}`]) !== null && _b !== void 0 ? _b : colorSchemeToMetricDirection['Default'],
        computationFilePath: (metricWithFilePath === null || metricWithFilePath === void 0 ? void 0 : metricWithFilePath.filePath) || DEFAULT_METADATA.computationFilePath,
        metricTemplate: '',
        instanceIdToBeEdited: '',
    };
};
export const convertDefinitionToMdl = (values) => {
    const createExperience = values.metadata.mode === METRIC_AUTHORING_MODE.custom ? CREATE_EXPERIENCE.metricWizard : CREATE_EXPERIENCE.rawMode;
    const definition = values.metadata.mode === METRIC_AUTHORING_MODE.custom
        ? { metricDefinition: values.metricDefinition, aggregation: values.aggregation }
        : { definition: '' }; // TO DO: integrate raw mode
    const metricMetaData = Object.assign(Object.assign({}, values.metadata), { level: values.metadata.level, createExperience: createExperience, fullMetricDefinition: definition });
    return mdlMetricDefinitionGenerator(metricMetaData);
};
export const getDescriptionComputationTemplate = (computationTemplates, templateName) => {
    var _a;
    var computationTemplate = computationTemplates === null || computationTemplates === void 0 ? void 0 : computationTemplates.find((item) => item.i['@TemplateName'] === templateName);
    return ((_a = computationTemplate === null || computationTemplate === void 0 ? void 0 : computationTemplate.i.TemplateDescription) === null || _a === void 0 ? void 0 : _a['#cdata-section']) || '';
};
export const templateParameterMap = (computationTemplate, parameterValues) => {
    var _a;
    return (_a = computationTemplate === null || computationTemplate === void 0 ? void 0 : computationTemplate.i.TemplateParameters.TemplateParameter) === null || _a === void 0 ? void 0 : _a.reduce((acc, param, index) => {
        var _a;
        acc[param['@Name']] = (_a = parameterValues[index]) === null || _a === void 0 ? void 0 : _a.value;
        return acc;
    }, {});
};
export const replaceParameterValues = (str, lookupMap) => {
    const value = str.replace(/^[\n\s]+|[\n\s]+$/g, '').replace(/,\s*/, ', '); // trim white spaces and next lines, put spaces after commas to allow for line breaks
    return value.replace(/\$\{([^}]+)\}/g, (_, item) => (lookupMap[item] ? lookupMap[item] : `\${${item}}`)); // replaces keys with values from lookupmap
};
export const getMetricsFromComputationTemplate = (computationTemplate, parameterValues) => {
    var _a;
    const lookup = templateParameterMap(computationTemplate, parameterValues) || {};
    return (((_a = computationTemplate === null || computationTemplate === void 0 ? void 0 : computationTemplate.i.TemplateDefinition.i) === null || _a === void 0 ? void 0 : _a.filter((item) => item['@c'] === '{extension://MDLConverters/ForayConverter}Statistic').map((item) => {
        var _a, _b, _c;
        return ({
            name: replaceParameterValues(((_a = item['foray:DisplayName']) === null || _a === void 0 ? void 0 : _a['#text']) || item['foray:DisplayName'] || '', lookup),
            level: replaceParameterValues(item['@Levels'], lookup),
            internalName: replaceParameterValues(item['@Name'], lookup),
            definition: replaceParameterValues(((_b = item['foray:Definition']) === null || _b === void 0 ? void 0 : _b['#cdata-section']) || '', lookup),
            description: replaceParameterValues(((_c = item['foray:Description']) === null || _c === void 0 ? void 0 : _c['#cdata-section']) || '', lookup),
            colorScheme: replaceParameterValues(item['@ColorScheme'] || '', lookup),
        });
    })) || []);
};
export const getColumnsFromComputationTemplate = (computationTemplate, parameterValues) => {
    var _a;
    const lookup = templateParameterMap(computationTemplate, parameterValues) || {};
    return (((_a = computationTemplate === null || computationTemplate === void 0 ? void 0 : computationTemplate.i.TemplateDefinition.i) === null || _a === void 0 ? void 0 : _a.filter((item) => item['@c'] === 'Column').map((item) => {
        var _a, _b, _c;
        return ({
            level: replaceParameterValues(item['@Level'] || '', lookup),
            name: replaceParameterValues(item['@Name'] || '', lookup),
            definition: ((_a = item.Definition) === null || _a === void 0 ? void 0 : _a['#cdata-section'])
                ? replaceParameterValues(((_b = item.Definition) === null || _b === void 0 ? void 0 : _b['#cdata-section']) || '', lookup)
                : replaceParameterValues(((_c = item.Definition) === null || _c === void 0 ? void 0 : _c['#text']) || '', lookup),
        });
    })) || []);
};
export const getQuickValidateRequest = (mode, preview, metrics, columns, values) => {
    const category = mode === MAUIMODES.edit ? 3 : 2; // 2 for add or clone, 3 for edit
    if (values.metadata.mode === METRIC_AUTHORING_MODE.template) {
        return {
            metricObjects: metrics.map((metric) => ({
                name: metric.internalName || metric.name,
                level: metric.level,
                definition: metric.definition,
                category: category,
            })),
            columnObjects: columns.map((column) => ({
                name: column.name,
                level: column.level,
                definition: column.definition,
                category: category,
            })),
        };
    }
    else {
        return {
            metricObjects: [
                {
                    name: values.metadata.internalName,
                    level: values.metadata.level,
                    definition: values.metadata.mode === METRIC_AUTHORING_MODE.code ? values.rawModeMdl : preview,
                    category: category,
                },
            ],
            columnObjects: [],
        };
    }
};
export const getQuickValidationNames = (metrics, columns, values) => {
    if (values.metadata.mode === METRIC_AUTHORING_MODE.template) {
        return metrics.map((metric) => metric.internalName)[0] || '';
    }
    else {
        return values.metadata.internalName;
    }
};
export const transformQuickCompileResult = (metricsObject, quickCompileAPIResult) => {
    return metricsObject.map((metricColumn) => ({
        name: metricColumn.name,
        status: !!quickCompileAPIResult[metricColumn.name] ? QuickCompilationStatuses.Failed : QuickCompilationStatuses.Succeeded,
        errorMessage: !!quickCompileAPIResult[metricColumn.name] ? quickCompileAPIResult[metricColumn.name] : '',
    }));
};
export const isQuickCompilationSuccessful = (quickCompileResult) => {
    return quickCompileResult.every((item) => item.status === QuickCompilationStatuses.Succeeded);
};
export const getPrimaryDataSourceFromMdl = (dataSourceMDL) => {
    const dataSourceList = dataSourceMDL.Mdl.Namespaces.Namespace.Tables.Table.DataSources.DataSource;
    if (!dataSourceList) {
        return '';
    }
    else if (Array.isArray(dataSourceList)) {
        return dataSourceList === null || dataSourceList === void 0 ? void 0 : dataSourceList.filter((dataSource) => dataSource['@Name'] !== 'FlashResalt')[0].DataSourceManagement['@Name'];
    }
    return dataSourceList.DataSourceManagement['@Name'];
};

//# sourceMappingURL=MetricWizard.utils.js.map
